import { Link } from "react-router-dom";
import OrderProgressTracker from "@/components/OrderProgressTracker.jsx";
import OrderThumbnail from "@/components/OrderThumbnail.jsx";
import { ORDER_ROUTE } from "@/utils/constants.js";
import "@/components/order-progress.css";

export default function HomeActiveOrders({ orders = [] }) {
    if (orders.length === 0) {
        return null;
    }

    return (
        <section className="home-active-orders" aria-label="Vos commandes en cours">
            <div className="home-active-orders-list">
                {orders.map((order) => (
                    <Link
                        key={order.orderId}
                        to={ORDER_ROUTE(order.orderId)}
                        className="home-active-order-card"
                    >
                        <OrderThumbnail order={order} variant="home" />
                        <div className="home-active-order-body">
                            <OrderProgressTracker order={order} variant="compact" />
                        </div>
                        <span className="home-active-order-chevron" aria-hidden="true">›</span>
                    </Link>
                ))}
            </div>
        </section>
    );
}
